import React from 'react';
import { Link } from 'react-router-dom';
import { HelpHero } from '../components/HelpHero';
import { Breadcrumb } from '../components/Breadcrumb';
import { CreditCard, FileText, ShieldCheck } from 'lucide-react';
import { articles, categories } from '../data/articles';
export function PaymentsPage() {
  const categoryArticles = articles.filter(a => a.categorySlug === 'pagos-y-facturas');
  return <div className="min-h-screen bg-[#f8fafc]" data-id="element-358">
      <HelpHero title="Pagos y Facturas" subtitle="Información clara sobre tus transacciones y comprobantes fiscales." showSearch={true} data-id="element-359" />

      <main className="max-w-7xl mx-auto px-4 md:px-8 py-10" data-id="element-360">
        <div className="flex flex-col lg:flex-row gap-10" data-id="element-361">
          {/* Left Sidebar */}
          <aside className="w-full lg:w-1/4 flex-shrink-0" data-id="element-362">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 sticky top-6" data-id="element-363">
              <h3 className="font-bold text-[#022a3b] mb-4 text-lg" data-id="element-364">
                Centro de Ayuda
              </h3>
              <nav className="space-y-1" data-id="element-365">
                {categories.map(category => <Link key={category.slug} to={`/${category.slug}`} className={`block py-2.5 px-3 rounded-md transition-colors ${category.slug === 'pagos-y-facturas' ? 'bg-[#f0f9ff] text-[#0af] font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-[#022a3b]'}`} data-id="element-366">
                    {category.name}
                  </Link>)}
              </nav>
            </div>
          </aside>

          {/* Right Content */}
          <div className="w-full lg:w-3/4" data-id="element-367">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-10 mb-8" data-id="element-368">
              <Breadcrumb items={[{
              label: 'Pagos y Facturas'
            }]} data-id="element-369" />

              <div className="flex items-center gap-3 mb-8" data-id="element-370">
                <div className="p-2 bg-[#e0f2fe] rounded-lg text-[#0af]" data-id="element-371">
                  <CreditCard className="h-6 w-6" data-id="element-372" />
                </div>
                <h1 className="text-3xl font-bold text-[#022a3b]" data-id="element-373">
                  Pagos y Facturas
                </h1>
              </div>

              <p className="text-gray-600 mb-8" data-id="element-374">
                Consulta aquí toda la información sobre pagos de pedidos y
                facturas.
              </p>

              <div className="space-y-0 divide-y divide-gray-100" data-id="element-375">
                {categoryArticles.map(article => <Link key={article.slug} to={`/${article.slug}`} className="block py-4 text-[#022a3b] hover:text-[#0af] transition-colors" data-id="element-376">
                    {article.title}
                  </Link>)}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-377">
              <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm flex items-start gap-4" data-id="element-378">
                <div className="bg-blue-50 p-3 rounded-full text-blue-600" data-id="element-379">
                  <FileText className="h-6 w-6" data-id="element-380" />
                </div>
                <div data-id="element-381">
                  <h3 className="font-bold text-[#022a3b] mb-2" data-id="element-382">
                    Portal de Facturación
                  </h3>
                  <p className="text-gray-600 text-sm mb-4" data-id="element-383">
                    Genera tus facturas de manera automática desde nuestro
                    portal de autoservicio.
                  </p>
                  <a href="#" className="text-[#0af] font-medium text-sm hover:underline" data-id="element-384">
                    Ir al portal →
                  </a>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm flex items-start gap-4" data-id="element-385">
                <div className="bg-green-50 p-3 rounded-full text-green-600" data-id="element-386">
                  <ShieldCheck className="h-6 w-6" data-id="element-387" />
                </div>
                <div data-id="element-388">
                  <h3 className="font-bold text-[#022a3b] mb-2" data-id="element-389">
                    Pagos Seguros
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-390">
                    Tus transacciones están protegidas con encriptación SSL de
                    256 bits.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}